import { QueryOptions } from '@apollo/client/core';

import Service from '@root/common/base/Service';
import { ServiceInterface } from '@root/common/types/service';
import { Weather } from '@root/modules/weather/typings/weather';
import getWeather from '@root/modules/weather/graphql/getWeather.graphql';
import { dataLoader, RedisDataLoaderOptions } from '@root/libs/redis/dataloader/dataLoader';

type ServiceVariables = Weather.FetchWeather['variables'];
type Response = Record<string, unknown> | null;

export default class WeatherService extends Service implements ServiceInterface {
  public async fetch(variables: ServiceVariables) {
    if (variables.placeId && /,/.test(variables.placeId)) {
      const coords = variables.placeId.split(',');
      variables.placeId = undefined;
      variables.lat = coords[0];
      variables.lon = coords[1];
    }

    try {
      const options = Object.assign({ query: getWeather }, { variables });
      const dataLoaderOptions: RedisDataLoaderOptions = {
        remote: {
          keyPrefix: 'weather',
        },
      };

      const requestWrapper = async (options: QueryOptions) => {
        const apiProvider = this.createProvider('GraphQL');
        apiProvider.selectAPI('weather-api').setLinkOptions({ useAutomaticPersistedQueries: true, useGETAutomaticPersistedQueries: true });

        const [response] = await apiProvider.query<Weather.FetchWeather['data']>(options);

        return response.data.weather || null;
      };

      const redisDataLoader = dataLoader<QueryOptions, Response>(requestWrapper, dataLoaderOptions);
      const response: Response = redisDataLoader ? await redisDataLoader.load(options) : await requestWrapper(options);

      return response;
    } catch (e) {
      const error = this.generateErrorData(e);
      this.handleError(error);
    }
  }
}
